// -- Framework imports --
import type { App, Plugin } from 'vue';
import axios from 'axios';

// -- Define plugin --
const AsteriskPlugin: Plugin = {
	install: (app: App) => {
		app.config.globalProperties.$asterisk = Asterisk;
	},
};

// -- Global Asterisk interface available in app --
const Asterisk = {
	applyChanges: (components: string[] | undefined = undefined) => {
		return axios.post('asterisk/config/apply', components);
	},
	hasPendingChanges: () => {
		return axios.get('asterisk/config/has_pending_changes').then((res) => !!res.data);
	},
	dialNumberOnPhone: (number: string) => {
		alert('Dialing onto phone not supported yet, will call via regular tel: link');

		const link = document.createElement('a');

		link.href = `tel:${number}`;
		link.click();
	},
};

// -- Exports --
export default AsteriskPlugin;

export { Asterisk };

declare module '@vue/runtime-core' {
	export interface ComponentCustomProperties {
		$asterisk: typeof Asterisk;
	}
}
